import React, { ReactElement, useState } from 'react';
import { Button, FormGroup, LoaderButton } from 'idsk-react-components';
import { useNavigate, useParams } from 'react-router';
import { ConfirmModal } from 'slovlex-idsk-react-components';
import { SafeParameterSetter } from '../../../../types/SafeParameterSetter';
import useFieldErrorMessages from '../../../useFieldErrorMessages';
import {
  ObalMaterialuNrSr as ObalMaterialuNrSrFormData,
} from '../../../../model/sprievodnyDokument/obalMaterialu/ObalMaterialuNrSr';
import { ClientResponse } from '../../../../model/ClientResponse';
import routes from '../../../../routing/routes';
import { useSuccessMessageContext } from '../../../../context/SuccessMessageContext';
import ObalMaterialuNrSrComponent from './component/ObalMaterialuNrSrComponent';
import { ClientStatus } from '../../../../model/ClientStatus';
import ObalMaterialuNrSrFillSystemDataButton from './component/ObalMaterialuNrSrFillSystemDataButton';
import './obalMaterialuNrSr.scss';
import { pouzivatelIsAdmin } from '../../../../function/permissions';
import { useUserContext } from '../../../../context/UserContext';

interface Props {
  initFormData: ObalMaterialuNrSrFormData;
  onSubmitForm: (formData: ObalMaterialuNrSrFormData) => Promise<ClientResponse<void>>
  fillSystemDataClient(...args): Promise<ClientResponse<ObalMaterialuNrSrFormData>>;
  fillSystemData: ObalMaterialuNrSrFormData;
  fillSystemDataStatus: ClientStatus;
  submitStatus: ClientStatus;
}
export const ObalMaterialuNrSr = ({
  initFormData,
  onSubmitForm,
  fillSystemDataStatus,
  fillSystemDataClient,
  fillSystemData,
  submitStatus,
}: Props): ReactElement => {
  const [obalMaterialu, setObalMaterialu] = useState<ObalMaterialuNrSrFormData>(initFormData);
  const { clearFieldErrorMessage } = useFieldErrorMessages();
  const { displaySuccess } = useSuccessMessageContext();
  const navigate = useNavigate();
  const {
    type,
    year,
    index,
    stadiumUuid,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, stadiumUuid: string }>();
  const { pouzivatel } = useUserContext();
  const updateField: SafeParameterSetter<ObalMaterialuNrSrFormData> = (fieldName, value) => {
    setObalMaterialu(prevState => ({
      ...prevState,
      [fieldName]: value,
    }));
    clearFieldErrorMessage(fieldName);
  };

  const onSubmit = async (): Promise<void> => {
    await onSubmitForm(obalMaterialu);
    navigate(
      pouzivatelIsAdmin(pouzivatel)
        ? routes.procesy.detail.sprievodneDokumenty.editAsAdmin.withParams(type, year, index, stadiumUuid)
        : routes.procesy.detail.sprievodneDokumenty.edit.withParams(type, year, index),
    );
    displaySuccess('Dokument bol úspešne uložený');
  };

  return (
    <>
      <ObalMaterialuNrSrFillSystemDataButton
        setObalMaterialu={setObalMaterialu}
        fillSystemDataStatus={fillSystemDataStatus}
        fillSystemData={fillSystemData}
        fillSystemDataClient={fillSystemDataClient}
      />
      <ObalMaterialuNrSrComponent obalMaterialu={obalMaterialu} updateField={updateField} />
      <FormGroup className="obal-materialu-nrsr__form-buttons">
        <ConfirmModal
          question="Naozaj si prajete uložiť formulár a vytvoriť sprievodný dokument?"
          description={'Ak upravujete existujúci formulár, budú údaje tohto formulára prepísané '
            + 'a výsledný dokument, ktorý vznikol na základe tohto formulára, bude nahradený.'}
          cancelButtonText="Nie"
          confirmButton={
            (
              <Button
                buttonStyle="action"
                size="large"
              >
                Áno
              </Button>
            )
          }
          openButton={(
            <LoaderButton
              loading={submitStatus.loading}
              type="submit"
              size="large"
              disableOutsideClickWhileLoading
            >Uložiť
            </LoaderButton>
          )}
          doAfterConfirm={() => onSubmit()}
        />
        <Button
          className="obal_materialu__buttons"
          type="button"
          buttonStyle="third"
          size="large"
          disabled={submitStatus.loading}
          onClick={() => navigate(-1)}
        >Späť
        </Button>
      </FormGroup>
    </>
  );
};

export default ObalMaterialuNrSr;
